export enum UserRoleType {
  Internal = 'ROLE_INTERNAL_USER',
  InternalAdmin = 'ROLE_INTERNAL_ADMIN',
  Expert = 'ROLE_EXPERT_USER',
  CompanyAdmin = 'ROLE_COMPANY_ADMIN',
  Company = 'ROLE_COMPANY_USER'
}
